import * as panelActions from "../actions/panelActions";
import {updateObject} from "../../utils/util";
import produce from "immer";

const initialState = {
  beneficiariesLoaded: false,
  credentialSVG: null,
  receiptPaymentSVG: null
};

export function panelReducer(state = initialState, action) {
  switch (action.type) {
    case panelActions.BENEFICIARIES_LOADED:
      return updateObject(state, { ...action.panel });
    case panelActions.CLEAR_PANEL:
      return initialState;
    case panelActions.ADD_CREDENTIAL_SVG:
      return produce(state, drafState => {
        drafState.credentialSVG = action.credential;
      });
    case panelActions.ADD_RECEIPT_PAYMENT_SVG:
      return produce(state, drafState => {
        drafState.receiptPaymentSVG = action.receipt;
      });
    default:
      return state;
  }
}